/// <reference path='../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../typings/tsd.d.ts' />
//controllers
import {AlertController} from "./controllers/alertcontroller";
import 'ng-toast';
//services
import {AlertService} from "./service/alertservice";
var alertmodule = angular.module('hibachi.alert',['ngToast'])
.config(['ngToastProvider', function(ngToastProvider) {
    
  //ngToast lib from https://github.com/tameraydin/ngToast
  ngToastProvider.configure({
    animation: 'slide', // or 'fade'
    dismissButton: true, //default= false
    dismissOnClick: false, //default=true
    additionalClasses: '', //left empty, can be used for styling
    horizontalPosition: 'center', //'right', 'left' or 'center'
    verticalPosition: 'top', //defaut=top
    timeout:	4000, // alert-fadeing timeout, in milis
    maxNumber:	0,	//Maximum number of toast messages to display. (0 = no limit) (number)
    combineDuplications: false, //default=fasle, If enabled, toast messages with the same content & type will be merged and the count number will be displayed at the beginning of message. (boolean)
    newestOnTop: true,	//default=true , Adds newly created toast messages on top of old ones. (boolean)
      
  });
}])
//controllers
.controller('alertController',AlertController)
//services
.service('alertService',AlertService)
;
export{
	alertmodule
};
